import React, { useState, useEffect } from 'react';
import { Moon, Calendar } from 'lucide-react';

const RamadanCountdown = () => {
  const [timeLeft, setTimeLeft] = useState({
    weeks: 0,
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    isRamadan: false
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const ramadanStart = new Date('2026-02-19T00:00:00');
      const ramadanEnd = new Date('2026-03-31T23:59:59');
      const now = new Date();

      // إذا كنا في رمضان
      if (now >= ramadanStart && now <= ramadanEnd) {
        return {
          weeks: 0,
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
          isRamadan: true
        };
      }

      // إذا رمضان لسه جاي
      if (now < ramadanStart) {
        const difference = ramadanStart - now;
        
        const seconds = Math.floor((difference / 1000) % 60);
        const minutes = Math.floor((difference / 1000 / 60) % 60);
        const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
        const totalDays = Math.floor(difference / (1000 * 60 * 60 * 24));
        const weeks = Math.floor(totalDays / 7);
        const days = totalDays % 7;

        return {
          weeks,
          days,
          hours,
          minutes,
          seconds,
          isRamadan: false
        };
      }

      // رمضان عدى
      return {
        weeks: 0,
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        isRamadan: false
      };
    };

    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    setTimeLeft(calculateTimeLeft());

    return () => clearInterval(timer);
  }, []);

  // لو احنا في رمضان، ما نعرضش التايمر
  if (timeLeft.isRamadan) {
    return null;
  }

  return (
    <div className="w-full max-w-4xl mx-auto mb-8">
      <div className="bg-gradient-to-br from-purple-900/40 to-indigo-900/40 backdrop-blur-lg rounded-2xl p-6 border border-white/10 shadow-2xl">
        <div className="flex items-center justify-center gap-2 mb-4">
          <Moon className="w-6 h-6 text-yellow-300" />
          <h3 className="text-xl md:text-2xl font-bold text-yellow-300" dir="rtl">
            باقي على رمضان
          </h3>
          <Calendar className="w-6 h-6 text-yellow-300" />
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-5 gap-3 md:gap-4">
          {/* الأسابيع */}
          <div className="bg-white/10 rounded-xl p-4 backdrop-blur-sm border border-white/20">
            <div className="text-3xl md:text-4xl font-bold text-yellow-300 mb-1">
              {String(timeLeft.weeks).padStart(2, '0')}
            </div>
            <div className="text-xs md:text-sm text-purple-200" dir="rtl">
              أسبوع
            </div>
          </div>

          {/* الأيام */}
          <div className="bg-white/10 rounded-xl p-4 backdrop-blur-sm border border-white/20">
            <div className="text-3xl md:text-4xl font-bold text-yellow-300 mb-1">
              {String(timeLeft.days).padStart(2, '0')}
            </div>
            <div className="text-xs md:text-sm text-purple-200" dir="rtl">
              يوم
            </div>
          </div>

          {/* الساعات */}
          <div className="bg-white/10 rounded-xl p-4 backdrop-blur-sm border border-white/20">
            <div className="text-3xl md:text-4xl font-bold text-yellow-300 mb-1">
              {String(timeLeft.hours).padStart(2, '0')}
            </div>
            <div className="text-xs md:text-sm text-purple-200" dir="rtl">
              ساعة
            </div>
          </div>

          {/* الدقائق */}
          <div className="bg-white/10 rounded-xl p-4 backdrop-blur-sm border border-white/20">
            <div className="text-3xl md:text-4xl font-bold text-yellow-300 mb-1">
              {String(timeLeft.minutes).padStart(2, '0')}
            </div>
            <div className="text-xs md:text-sm text-purple-200" dir="rtl">
              دقيقة
            </div>
          </div>

          {/* الثواني */}
          <div className="bg-white/10 rounded-xl p-4 backdrop-blur-sm border border-white/20 col-span-2 md:col-span-1">
            <div className="text-3xl md:text-4xl font-bold text-yellow-300 mb-1">
              {String(timeLeft.seconds).padStart(2, '0')}
            </div>
            <div className="text-xs md:text-sm text-purple-200" dir="rtl">
              ثانية
            </div>
          </div>
        </div>

        <div className="mt-4 text-center">
          <p className="text-sm text-purple-200" dir="rtl">
            اللهم بلغنا رمضان 🌙
          </p>
        </div>
      </div>
    </div>
  );
};

export default RamadanCountdown;
